//@flow
import api from '../Utils/apiBuilder';
import Constants from '../constants';

export default {
  getTokenWithUsernamePassword(username:string, password:string) {
    return api('tokens').noauth().post({ username, password, grant_type: "password" }).dispatch(Constants.LOGIN);
  },

  getTokenWithFacebook(fbToken:string) {
    api('tokens').noauth()
      .post({
        facebook_token: fbToken,
        grant_type: "facebook",
      }).dispatch(Constants.LOGIN);
  },

  getTokenWithMagicLink(magicLinkToken:string) {
    api('tokens').noauth()
      .post({
        magiclink_token: magicLinkToken,
        grant_type: 'magiclink',
      }).dispatch(Constants.LOGIN);
  },

  getTokenWithSoftLink(softLinkToken:string) {
    api('tokens').noauth()
      .post({
        softlink_token: softLinkToken,
        grant_type: 'softlink',
      }).dispatch(Constants.LOGIN);
  },

  revokeToken(token:string) {
    return api('tokens/revoke').softAuth()
      .post({
        token,
        token_type_hint: 'access_token',
      }).dispatch(Constants.LOGGED_OUT);
  },
};
